// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"1887bf72","453":"81b91a0d"}[chunkId] + ".chunk.js";
};